import { useEffect, useState } from "react";
import { MailchimpModalActions } from "../../context/MailchimpModalContext";

export default function MailchimpModalForm() {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const { isOpenMailchimpModal, setIsOpenMailchimpModal } = MailchimpModalActions();

  useEffect(() => {
    if (isOpenMailchimpModal) {
      setShowModal(isOpenMailchimpModal);
    }
  }, [isOpenMailchimpModal]);

  useEffect(() => {
    if (!showModal) {
      setIsOpenMailchimpModal(false);
    }
  }, [showModal]);

  useEffect(() => {
    let timer;

    const handleUserIntent = () => {
      timer = setTimeout(() => {
        setShowModal(true);
      }, 7000);
      window.removeEventListener("mousemove", handleUserIntent);
      window.removeEventListener("scroll", handleUserIntent);
    };

    window.addEventListener("mousemove", handleUserIntent);
    window.addEventListener("scroll", handleUserIntent);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", handleUserIntent);
      window.removeEventListener("scroll", handleUserIntent);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("EMAIL", email);

    try {
      await fetch(
        "https://facebook.us16.list-manage.com/subscribe/post?u=389edf5542ead707667f9a168&amp;id=fa23a7dab4&amp;f_id=003705e0f0",
        {
          method: "POST",
          mode: "no-cors",
          body: formData,
        }
      );
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-[9999999] bg-black bg-opacity-50 flex items-center justify-center md:px-0 px-4 transition-opacity duration-800 ease-in-out opacity-100 fade-in">
      <div className="bg-[#fffff6] border-giek-purple text-giek-purple rounded-2xl shadow-xl max-w-md w-full p-6 relative transform transition-all duration-700 ease-in-out translate-y-0 opacity-100 animate-slideFadeIn">
        <button
          className="absolute top-2 right-4 text-giek-purple hover:text-black text-4xl"
          onClick={() => setShowModal(false)}
        >
          &times;
        </button>

        <h2 className="text-3xl text-left font-semibold mb-4 font-print text-strange-green font-bold italic mt-6 w-full text-center">
          Stay sane!
        </h2>
        <p className="text-giek-purple font-bold text-lg mb-2 font-print text-strange-green w-full text-left w-full text-center">
          Sign up for our newsletter and you'll be fixed.
          <br />
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            name="EMAIL"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            required
            className="font-secondary py-1 px-2 input border border-strange-green bg-transparent font-print rounded-md text-lg w-full input-bordered font-bold py-4 px-4"
          />
          <div className="w-full drop-shadow-cta p-1 px-0 rounded bg-cta-container-bg mt-2 w-full mx-auto min-w-64 flex justify-center">
            <button
              type="submit"
              className="font-secondary  text-xl w-full rounded-sm font-print bg-strange-green text-white py-3 px-2 py-1 uppercase"
            >
              Subscribe
            </button>
          </div>
        </form>

        {status === "success" && (
          <p className="text-green-600 mt-4">Thanks for subscribing!</p>
        )}
        {status === "error" && (
          <p className="text-red-600 mt-4">Something went wrong. Please try again.</p>
        )}
      </div>
    </div>
  );
}
